import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { useCosmos } from "@/modules/cosmos/stores/use-cosmos-store"
import LoginForm from "@/modules/login/components/form"

export default function TraditionalLogin() {
  const { cosmos } = useCosmos()

  return (
    <div className="flex min-h-screen w-full flex-col">
      <div className="flex flex-1 flex-col items-center justify-center bg-neutral-100 px-4 py-12">
        <div className="w-full max-w-[440px]">
          <Card className="border border-neutral-200 bg-white shadow-md">
            <CardHeader className="space-y-2 pb-8">
              <CardTitle className="flex items-center gap-4">
                <img
                  width={56}
                  height={56}
                  src={cosmos.meta.logoUrl}
                  alt="Logo Siglo 21"
                  className="h-14 w-14 rounded-xl object-contain"
                />
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6">
              <LoginForm />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
